import { AUTHORITY_COMMUNITY, AUTHORITY_OFFICIAL } from '../constants';

export const provenanceIcon = (provenance: string, useForgeIcon: boolean = false) => {
  if (provenance === AUTHORITY_OFFICIAL) {
    return useForgeIcon ? 'check_decagram' : 'official2';
  }
  if (provenance === AUTHORITY_COMMUNITY) {
    return useForgeIcon ? 'account_group' : 'community';
  }
  if (!provenance) {
    return null;
  }
};
